// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.wT_34UDhYgAjMAY_8LX6 {
  width: 230px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  border: none;

  padding: 8px;

  cursor: pointer;
  transition: .3s;

  color: black;
}

.wT_34UDhYgAjMAY_8LX6:hover {
  background-color: #F4F5F7;
  color: black;
}

.wT_34UDhYgAjMAY_8LX6 .uK7yAl4ZqIsgN2EiMnih {
  margin-left: 8px;
}

.wT_34UDhYgAjMAY_8LX6 .uK7yAl4ZqIsgN2EiMnih p {
  margin: 0;
  text-align: left;
}

.wT_34UDhYgAjMAY_8LX6 .uK7yAl4ZqIsgN2EiMnih .QzHU6vZ3KnnwZshdKMeC {
  font-family: Roboto, sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
}

.wT_34UDhYgAjMAY_8LX6 .uK7yAl4ZqIsgN2EiMnih .yAcWIBVpLlPFgg94e8pW {
  font-family: Roboto, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
}

.wT_34UDhYgAjMAY_8LX6 img {
  width: 50px;
  height: 50px;
  border-radius: 5px;
  object-fit: cover;
}

.XiH5m1unpjUMQSx3SRb7 {
  width: 42px;
  height: 42px;
  background: linear-gradient(320.01deg, #526AF2 7.61%, #7C8EF7 96.39%);
  border-radius: 5px;
  color: white;

  display: flex;
  justify-content: center;
  align-items: center;
}

.XiH5m1unpjUMQSx3SRb7 p {
  margin: 0;
  font-size: 18px;
  font-weight: 400;
}

.dwEK4BFTfEEizBF4K5g5 {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-left: 8px;
}

.AIWpF9XKbY4A2cxf0hhS {
  position: relative;
}

.S9AOhwTb4CfyaHuyRBHQ {
  position: absolute;
  background-color: #F4F5F7;
  border-radius: 5px;
  width: 230px;
  margin: auto;
  top: 70px;
  box-shadow: 0 1px 7px rgba(0, 0, 0, 0.15);
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.scbDi9Y_BovmxJP4bOkg {
  all: unset;
  font-family: Roboto, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  color: #72757E;

  background: none;
  border: none;

  cursor: pointer;

  width: 100%;
  text-align: left;
  padding: 8px;

  transition: .3s;
}

.scbDi9Y_BovmxJP4bOkg:hover {
  width: 100%;
  color: #72757E;
  background-color: #E3E3E3;
}

.BCpd83Ni9jusj4_3hqZO {
  margin: 0 0 8px;
}

.mUzB_RILRZzoMfUExTvA {
  margin-bottom: 0;
}

.N3dDKrpLlec5Aj0CmdAd {
  font-size: 14px;
  margin-right: 8px;
}

.UokX4D61CvO6GomnPRAR {
  display: flex;
  flex-direction: row;
  align-items: center;
}
`, "",{"version":3,"sources":["webpack://./src/components/Navigation/NavigationDashboard/NavigationDashboard.module.css"],"names":[],"mappings":";AACA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;;EAE9B,YAAY;;EAEZ,YAAY;;EAEZ,eAAe;EACf,eAAe;;EAEf,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qEAAqE;EACrE,kBAAkB;EAClB,YAAY;;EAEZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,SAAS;EACT,yCAAyC;EACzC,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,+BAA+B;EAC/B,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,cAAc;;EAEd,gBAAgB;EAChB,YAAY;;EAEZ,eAAe;;EAEf,WAAW;EACX,gBAAgB;EAChB,YAAY;;EAEZ,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB","sourcesContent":["\n.profile {\n  width: 230px;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n\n  border: none;\n\n  padding: 8px;\n\n  cursor: pointer;\n  transition: .3s;\n\n  color: black;\n}\n\n.profile:hover {\n  background-color: #F4F5F7;\n  color: black;\n}\n\n.profile .description {\n  margin-left: 8px;\n}\n\n.profile .description p {\n  margin: 0;\n  text-align: left;\n}\n\n.profile .description .name {\n  font-family: Roboto, sans-serif;\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n}\n\n.profile .description .space {\n  font-family: Roboto, sans-serif;\n  font-style: normal;\n  font-weight: normal;\n  font-size: 14px;\n}\n\n.profile img {\n  width: 50px;\n  height: 50px;\n  border-radius: 5px;\n  object-fit: cover;\n}\n\n.logoLetter {\n  width: 42px;\n  height: 42px;\n  background: linear-gradient(320.01deg, #526AF2 7.61%, #7C8EF7 96.39%);\n  border-radius: 5px;\n  color: white;\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.logoLetter p {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 400;\n}\n\n.expand {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  margin-left: 8px;\n}\n\n.relative {\n  position: relative;\n}\n\n.dropdown {\n  position: absolute;\n  background-color: #F4F5F7;\n  border-radius: 5px;\n  width: 230px;\n  margin: auto;\n  top: 70px;\n  box-shadow: 0 1px 7px rgba(0, 0, 0, 0.15);\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n\n.link {\n  all: unset;\n  font-family: Roboto, sans-serif;\n  font-style: normal;\n  font-weight: normal;\n  font-size: 14px;\n  color: #72757E;\n\n  background: none;\n  border: none;\n\n  cursor: pointer;\n\n  width: 100%;\n  text-align: left;\n  padding: 8px;\n\n  transition: .3s;\n}\n\n.link:hover {\n  width: 100%;\n  color: #72757E;\n  background-color: #E3E3E3;\n}\n\n.separator {\n  margin: 0 0 8px;\n}\n\n.group {\n  margin-bottom: 0;\n}\n\n.icon {\n  font-size: 14px;\n  margin-right: 8px;\n}\n\n.linkIcon {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"profile": `wT_34UDhYgAjMAY_8LX6`,
	"description": `uK7yAl4ZqIsgN2EiMnih`,
	"name": `QzHU6vZ3KnnwZshdKMeC`,
	"space": `yAcWIBVpLlPFgg94e8pW`,
	"logoLetter": `XiH5m1unpjUMQSx3SRb7`,
	"expand": `dwEK4BFTfEEizBF4K5g5`,
	"relative": `AIWpF9XKbY4A2cxf0hhS`,
	"dropdown": `S9AOhwTb4CfyaHuyRBHQ`,
	"link": `scbDi9Y_BovmxJP4bOkg`,
	"separator": `BCpd83Ni9jusj4_3hqZO`,
	"group": `mUzB_RILRZzoMfUExTvA`,
	"icon": `N3dDKrpLlec5Aj0CmdAd`,
	"linkIcon": `UokX4D61CvO6GomnPRAR`
};
export default ___CSS_LOADER_EXPORT___;
